/**
 * TanStack Query hooks for `google-ads-gclid-parallel-tracking-native-integrat`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	googleAdsGclidParallelTrackingNativeIntegratQueryKeys,
	type CreateGoogleAdsGclidParallelTrackingNativeIntegratBody,
	type ListGoogleAdsGclidParallelTrackingNativeIntegratResponse,
	type GoogleAdsGclidParallelTrackingNativeIntegratRow,
} from "./api";

export function useGoogleAdsGclidParallelTrackingNativeIntegratList(): UseQueryResult<ListGoogleAdsGclidParallelTrackingNativeIntegratResponse, Error> {
	return useQuery({
		queryKey: googleAdsGclidParallelTrackingNativeIntegratQueryKeys.list(),
		queryFn: list,
	});
}

export function useGoogleAdsGclidParallelTrackingNativeIntegratCreate(): UseMutationResult<GoogleAdsGclidParallelTrackingNativeIntegratRow, Error, CreateGoogleAdsGclidParallelTrackingNativeIntegratBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsGclidParallelTrackingNativeIntegratQueryKeys.all });
		},
	});
}

export function useGoogleAdsGclidParallelTrackingNativeIntegratDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: googleAdsGclidParallelTrackingNativeIntegratQueryKeys.all });
		},
	});
}
